module.exports = __webpack_public_path__ + "static/media/warning.f19a78a4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/warning.svg
// module id = 741
// module chunks = 0